// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { Fragment } from 'react';
import styled from 'styled-components';
import '../../styles/containers/Party.css';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { FormControl, ControlLabel } from 'react-bootstrap';
import NumericInput from '../utils/FormWidgets/NumericInput';
import TagSelector from '../utils/FormWidgets/TagsSelector';
import SimpleSelect from '../utils/FormWidgets/SimpleSelect';
import Error from '../stateMessage/Error';
import {
  StyledFilterFormGroup,
  StyledFilterTitle,
  StyledFilterWrapper,
} from '../utils/Styles/FilterStyles';
import CSVLinkButton from '../utils/CSVLinkButton';
import {
  ACTIVITIES_CSV_HEADERS,
  BOOKING_CSV_HEADERS,
} from '../../infrastructure/constants/activities';
import AutoCompleteSearch from '../utils/AutoCompleteSearch';

const StyledCommonFilterRow = styled.div`
  padding-top: 15px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  > div {
    width: 150px;
    margin-right: 20px;

    label {
      font-size: 16px;
    }
  }
`;

export class FilteredData {
  title = '';
  location = '';
  guests = undefined;
  price = '';
  bookable = 'both';
  bachified = 'both';
  tags = [];
  featured = 'both';
  hidden = 'both';
}

class State {
  filteredData = new FilteredData();
  isSuccsess = false;
  isError = false;
  isDeactive = false;
}

export default class FilterActivityForm extends React.Component {
  state = new State();

  componentDidMount() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { filterData } = this.props;
    if (filterData) {
      this.setState({ filteredData: filterData });
    }
  }

  componentWillUnmount() {
    this.setState({ isDeactive: true });
  }

  handleTitleChange = ({ target }) => {
    let { filteredData } = this.state;
    filteredData = {
      ...filteredData,
      title: target.value,
    };
    this.setState({ filteredData });
    if (target.value.length >= 3 || target.value.length === 0) {
      this.handleSubmit(filteredData);
    }
  };

  handleCurrencyChange = ({ target }) => {
    let { filteredData } = this.state;
    filteredData = {
      ...filteredData,
      price: target.value,
    };
    this.setState({ filteredData });
    this.handleSubmit(filteredData);
  };

  tagsChanged = (value, act) => {
    let { filteredData } = this.state;
    switch (act.action) {
      case 'select-option': {
        filteredData = {
          ...filteredData,
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          tags: [...filteredData.tags, act.option.value],
        };
        break;
      }
      case 'remove-value': {
        filteredData = {
          ...filteredData,
          tags: filteredData.tags.filter(
            tags => tags !== act.removedValue.value
          ),
        };
        break;
      }
      default: {
        break;
      }
    }
    this.setState({ filteredData });
    this.handleSubmit(filteredData);
  };

  hideMessage = () => {
    const { isDeactive } = this.state;
    if (!isDeactive) {
      this.setState({ isError: false });
    }
  };

  locationChanged = ({ value }) => {
    let { filteredData } = this.state;
    filteredData = {
      ...filteredData,
      location: value,
    };
    this.setState({ filteredData });
    this.handleSubmit(filteredData);
  };

  commonChange = (key, value) => {
    let { filteredData } = this.state;
    filteredData = {
      ...filteredData,
      [key]: value,
    };
    this.setState({ filteredData });
    this.handleSubmit(filteredData);
  };

  handleSubmit = async filteredData => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { filterActivity } = this.props;
    filterActivity(filteredData);
  };

  clear = () => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { clear } = this.props;
    this.setState({ filteredData: new FilteredData() });
    clear();
  };

  render() {
    const { filteredData, isError } = this.state;
    const {
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      cities,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      tags,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      isMobileFilterSelected,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      csvActivities,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      csvBookingOptions,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      loadCSVActivities,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      filterData,
    } = this.props;
    return (
      <Fragment>
        <div
          className={`form-content horizontal-form  filter-form ${
            isMobileFilterSelected ? 'mobile-filter-selected' : ''
          }`}
          style={{ paddingLeft: '0px' }}
        >
          <StyledFilterTitle>Filters</StyledFilterTitle>
          <StyledFilterWrapper>
            <StyledFilterFormGroup>
              <FormControl
                type='text'
                placeholder='Name (3 characters min)'
                onChange={this.handleTitleChange}
                value={filteredData.title}
              />
            </StyledFilterFormGroup>
            <StyledFilterFormGroup
              controlId='location'
              style={{
                paddingLeft: '0px',
                display: 'inline-block',
                width: '300px',
              }}
            >
              {
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                <AutoCompleteSearch
                  placeholder='Start typing to select city'
                  // TODO: Fix this the next time the file is edited.
                  // eslint-disable-next-line react/prop-types
                  datalist={cities.map(city => ({
                    value: city.name,
                    label: `${city.name} ${
                      city.status === 'active' ? '' : '(deactive)'
                    }`,
                  }))}
                  itemValuePropName='label'
                  onComplete={this.locationChanged}
                />
              }
            </StyledFilterFormGroup>
            <div style={{ width: '570px' }}>
              <TagSelector
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                placeholder='Select Tag'
                onChange={this.tagsChanged}
                value={filteredData.tags.map(tag => ({
                  value: tag,
                  label: tag,
                }))}
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line react/prop-types
                options={tags.map(tag => ({ value: tag, label: tag }))}
              />
            </div>
            <StyledCommonFilterRow>
              <StyledFilterFormGroup controlId='Featured'>
                <ControlLabel>Featured:</ControlLabel>
                <SimpleSelect
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  onChange={value => this.commonChange('featured', value)}
                  value={filteredData.featured}
                  placeholder='Featured'
                  data={[
                    { label: 'Both', value: 'both' },
                    { label: 'Yes', value: 'yes' },
                    { label: 'No', value: 'no' },
                  ]}
                />
              </StyledFilterFormGroup>
              <StyledFilterFormGroup controlId='Bookable'>
                <ControlLabel>Bookable:</ControlLabel>
                <SimpleSelect
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  onChange={value => this.commonChange('bookable', value)}
                  value={filteredData.bookable}
                  placeholder='Bookable'
                  data={[
                    { label: 'Both', value: 'both' },
                    { label: 'Yes', value: 'yes' },
                    { label: 'No', value: 'no' },
                  ]}
                />
              </StyledFilterFormGroup>
              <StyledFilterFormGroup controlId='Bachified'>
                <ControlLabel>Bachified:</ControlLabel>
                <SimpleSelect
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  onChange={value => this.commonChange('bachified', value)}
                  value={filteredData.bachified}
                  placeholder='Bachified'
                  data={[
                    { label: 'Both', value: 'both' },
                    { label: 'Yes', value: 'yes' },
                    { label: 'No', value: 'no' },
                  ]}
                />
              </StyledFilterFormGroup>
              <StyledFilterFormGroup controlId='Hidden'>
                <ControlLabel>Hidden:</ControlLabel>
                <SimpleSelect
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  onChange={value => this.commonChange('hidden', value)}
                  value={filteredData.hidden}
                  placeholder='Hidden'
                  data={[
                    { label: 'Both', value: 'both' },
                    { label: 'Yes', value: 'yes' },
                    { label: 'No', value: 'no' },
                  ]}
                />
              </StyledFilterFormGroup>
              <StyledFilterFormGroup style={{ width: '150px' }}>
                <ControlLabel>Max Price:</ControlLabel>
                <div
                  style={{
                    width: '110px',
                    marginRight: '0',
                  }}
                >
                  <NumericInput
                    onChange={this.handleCurrencyChange}
                    placeholder='0.00'
                    pattern='[0-9]+([\.,][0-9]+)?'
                    type='$'
                    value={filteredData.price}
                  />
                </div>
              </StyledFilterFormGroup>
              <button
                type='button'
                onClick={this.clear}
                className='btn btn-def panel-button'
                style={{
                  verticalAlign: 'top',
                  marginTop: '5px',
                }}
              >
                Clear all
              </button>
              {
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                <CSVLinkButton
                  data={[
                    {
                      id: 1,
                      items: csvActivities,
                      headers: ACTIVITIES_CSV_HEADERS,
                      fileName: 'activities.csv',
                    },
                    {
                      id: 2,
                      items: csvBookingOptions,
                      headers: BOOKING_CSV_HEADERS,
                      fileName: 'bookingOptions.csv',
                    },
                  ]}
                  filterData={filterData}
                  loadData={loadCSVActivities}
                />
              }
            </StyledCommonFilterRow>
          </StyledFilterWrapper>
          {isError && <Error text='server error' />}
        </div>
      </Fragment>
    );
  }
}
